import apiClient from './apiClient';

export const customEventsApi = {
  listEvents: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    if (filters.offset) {
      params.append('offset', filters.offset);
    }
    if (filters.tags?.length) {
      params.append('tags', filters.tags.join(','));
    }
    if (filters.complexity) {
      params.append('complexity', filters.complexity);
    }
    if (filters.timeframe) {
      params.append('timeframe', filters.timeframe);
    }

    const response = await apiClient.get(`/custom-events?${params.toString()}`);
    return response.data;
  },

  getEvent: async (eventId) => {
    const response = await apiClient.get(`/custom-events/${eventId}`);
    return response.data;
  },

  createEvent: async (eventData) => {
    const response = await apiClient.post('/custom-events', eventData);
    return response.data;
  },

  updateEvent: async (eventId, updates) => {
    const response = await apiClient.put(`/custom-events/${eventId}`, updates);
    return response.data;
  },

  patchEvent: async (eventId, updates) => {
    const response = await apiClient.patch(`/custom-events/${eventId}`, updates);
    return response.data;
  },

  deleteEvent: async (eventId) => {
    const response = await apiClient.delete(`/custom-events/${eventId}`);
    return response.data;
  },

  compileEvent: async (eventId) => {
    const response = await apiClient.post(`/custom-events/${eventId}/compile`);
    return response.data;
  },

  preflightEvent: async (eventData) => {
    const response = await apiClient.post('/custom-events/preflight', eventData);
    return response.data;
  },

  getNotifications: async (days = 7) => {
    const response = await apiClient.get(`/custom-events/notifications?days=${days}`);
    return response.data;
  },

  // The API honours customEventId only together with eventType=custom_event; without it the call
  // returned unrelated events (DWLF-305 finding).
  getHistoricalFires: async (eventId, days = 30, limit = 200, cursor) => {
    const response = await apiClient.get('/events', { params: { eventType: 'custom_event', customEventId: eventId, days, limit, ...(cursor ? { cursor } : {}) } });
    return response.data;
  }
};

export default customEventsApi;
